export function getLocalisedErrorCode(code: string | undefined) {
  if (code === undefined) {
    return unknownError;
  }
  if (code in CodeToMessage) {
    return CodeToMessage[code];
  } else {
    return unknownError;
  }
}

const unknownError = 'Er is iets misgegaan, probeer het opnieuw.';

/**
 * Should probably define a message for every code defined in the backend:
 * https://gitlab.innovattic.com/blendin-solutions/wisbits-backend/-/blob/develop/database/src/main/kotlin/com/innovattic/wisbits/ErrorCodes.kt
 */
const CodeToMessage: Record<string, string> = {
  /* eslint-disable @typescript-eslint/naming-convention */
  email_address_already_taken: 'Deze gebruiker bestaat al.',
  firebase_out_of_sync: 'Deze gebruiker bestaat al.',
  unsupported_content_type: 'Selecteer een geldig bestandsformaat.',
  dependencies_on_user:
    'Gebruiker kan niet verwijderd worden, omdat deze gebruiker al een Wisbit gemaakt heeft, of aan het maken is.',
  lesson_already_published: 'Deze les is al gepubliceerd.',
  already_subscribed_to_lesson: 'Je bent al geabonneerd op deze les.',
  tag_name_already_exists:
    'Er bestaat al een tag met deze naam in uw organisatie.',
  already_following_error: 'Je volgt al een of meer van deze tags',
  not_following_error: 'Je volgt een of meer van deze tags niet.',
  invalid_username_or_password: 'Ongeldige gebruikersnaam of wachtwoord.',
  invalid_role: 'Gebruikersrol komt niet overeen.',
  cannot_progress_lesson_not_subscribed:
    'Je bent niet geabonneerd op deze les.',
  cannot_progress_backwards: 'Kan niet achteruit gaan.',
  cannot_progress_past_future_meeting:
    'Kan niet verder gaan dan pagina met toekomstige vergadering.',
  lesson_not_valid_for_publishing:
    'Les kan niet worden gepubliceerd - sommige gegevens ontbreken.',
  user_limit_reached: 'Gebruikerslimiet bereikt.',

  unknown_error: unknownError,
};
